import React from 'react';
import PropTypes from 'prop-types';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { ButtonLoading } from '../../components/Button';

// Local confirmation dialog. ModalConfirmation cannot be reused: it fires
// onSubmit on every click and expresses no in-flight state, and widening it
// would touch its eleven other consumers.
const ModerationConfirmModal = ({ isOpen, body, isLoading, onCancel, onConfirm }) => (
  <Modal
    className="modal-confirmation"
    isOpen={isOpen}
    size="sm"
    toggle={isLoading ? undefined : onCancel}
  >
    <ModalHeader className="modal-header--center" toggle={isLoading ? undefined : onCancel}>
      Confirmation
    </ModalHeader>
    <ModalBody>
      <p className="text-center">{body}</p>
    </ModalBody>
    <ModalFooter>
      <Button color="secondary" disabled={isLoading} onClick={onCancel}>No</Button>
      <ButtonLoading
        color="primary"
        isLoading={isLoading}
        loadingMessage="Submitting..."
        onClick={onConfirm}
      >
        Yes
      </ButtonLoading>{' '}
    </ModalFooter>
  </Modal>
);

ModerationConfirmModal.propTypes = {
  isOpen: PropTypes.bool,
  body: PropTypes.string,
  isLoading: PropTypes.bool,
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

ModerationConfirmModal.defaultProps = {
  isOpen: false,
  body: 'Are you sure?',
  isLoading: false,
};

export default ModerationConfirmModal;
